import {
  userControllerGetCap,
  getUserControllerGetCapQueryKey,
} from '@/api/users/users'
import { CreateDream } from '@/features/dream/views/crete-dream'
import { client } from '@/features/query/client'
import CoinAnimation from '@/ui/loader'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/dreams/create')({
  component: RouteComponent,
  loader: async () => {
    return Promise.allSettled([
      client.prefetchQuery({
        queryKey: getUserControllerGetCapQueryKey(),
        queryFn: () => userControllerGetCap(),
      }),
    ])
  },
  pendingComponent: CoinAnimation,
})

function RouteComponent() {
  return <CreateDream />
}
